import styles from "./menus/NavMenu.module.css";
import menuIcon from "../../../assets/menu.svg";
import closeMenuIcon from "../../../assets/menuClose.svg";

// Define the possible component actions for the reducer to call.
export const ACTIONS = {
  SET_NAV_CLASS: "setNavClass",
  MENU_CLOSE: "menuClose",
  MENU_TOGGLE: "menuToggle",
  ADMIN_MENU_TOGGLE: "adminMenuToggle",
  OPTION_MENU_TOGGLE: "optionMenuToggle",
  AUDIT_MENU_TOGGLE: "auditMenuToggle",
  AUDIT_REPORTS_MENU_TOGGLE: "auditReportsMenuToggle",
};

// Define the state's initial values.
export const initialState = {
  // Ensure this screen width matches the media query in NavMenu.module.css.
  MAX_MOBILE_SCREEN_WIDTH: 1200,
  navClass: styles.nav,
  mobileMenuIcon: menuIcon,
  mobileMenuOpen: false,
  adminMenuOpen: false,
  optionMenuOpen: false,
  auditMenuOpen: false,
  auditReportsMenuOpen: false,
};

// Define the component's reducer with an action switch and state handling.
export const reducer = (state, action) => {
  switch (action.type) {
    case ACTIONS.SET_NAV_CLASS:
      return {
        ...state,
        navClass: action.value,
      };
    case ACTIONS.MENU_CLOSE:
      return {
        ...state,
        mobileMenuIcon: menuIcon,
        mobileMenuOpen: false,
        adminMenuOpen: false,
        optionMenuOpen: false,
        auditMenuOpen: false,
        auditReportsMenuOpen: false,
      };
    case ACTIONS.MENU_TOGGLE:
      return {
        ...state,
        mobileMenuIcon:
          state.mobileMenuOpen === true ? menuIcon : closeMenuIcon,
        mobileMenuOpen: state.mobileMenuOpen === true ? false : true,
        adminMenuOpen: false,
        optionMenuOpen: false,
      };
    case ACTIONS.ADMIN_MENU_TOGGLE:
      return {
        ...state,
        adminMenuOpen: state.adminMenuOpen === true ? false : true,
        auditMenuOpen: false,
      };
    case ACTIONS.OPTION_MENU_TOGGLE:
      return {
        ...state,
        optionMenuOpen: state.optionMenuOpen === true ? false : true,
      };
    case ACTIONS.AUDIT_MENU_TOGGLE:
      return {
        ...state,
        auditMenuOpen: state.auditMenuOpen === true ? false : true,
      };
    case ACTIONS.AUDIT_REPORTS_MENU_TOGGLE:
      return {
        ...state,
        auditReportsMenuOpen:
          state.auditReportsMenuOpen === true ? false : true,
      };
    default:
      return state;
  }
};
